export default __webpack_public_path__ + "static/media/runkeeper-track-after-3.6e017692.svg";